import {TelegramSaveFileModalFormField} from "../types/telegram-save-file-modal.types";

export const telegramSaveFileModalFields: Array<TelegramSaveFileModalFormField> = [
  {
    label: 'Id рекламы',
    fieldName: 'recordCalendarId',
    isNeedInput: true
  },
  {
    label: 'Привязать к',
    fieldName: 'destinationType'
  }
]
